import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, perm }) {
    const { user, loading, hasPerm } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-stone-50">
                <div className="text-stone-500 text-sm">Loading…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (perm && !hasPerm(perm)) {
        return (
            <div className="p-8">
                <div className="border border-stone-200 rounded-xl bg-white p-8">
                    <h2 className="text-xl font-semibold text-stone-900 mb-2">Access denied</h2>
                    <p className="text-stone-600 text-sm">Your role does not have permission to view this page.</p>
                </div>
            </div>
        );
    }
    return children;
}
